import { CallButton, QuoteButton } from "./Cta";

export default function MobileCallBar() {
  return (
    <div
      data-testid="mobile-call-bar"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-[1.4fr_1fr] gap-2 border-t border-slate-800 bg-[#0F1115]/95 p-2 backdrop-blur-xl md:hidden"
    >
      <CallButton id="mobile-bar-call" className="btn-brand w-full" label="Call Now" />
      <QuoteButton id="mobile-bar-quote" className="btn-ghost w-full !px-3" label="Quote" />
    </div>
  );
}
